import { Link, Outlet, useMatch } from 'react-router'
import { Logo } from '@/shared/ui/Logo'
import { ProfileMenu } from '@/features/auth/ProfileMenu'
import { ROUTES } from '@/shared/routes'
import { FilterBar } from '@/features/dashboard/filters/FilterBar'
import { ThemeToggle } from '@/shared/ui/ThemeToggle'
import styles from './AppShell.module.css'

export const AppShell = () => {
  // The filters sit in the sticky header, on the home dashboard only.
  const isHome = useMatch(ROUTES.HOME) !== null
  return (
    <div className={`${styles.layout} ${isHome ? styles.withFilters : ''}`}>
      <header className={styles.header}>
        <div className={styles.bar}>
          <Link to={ROUTES.HOME} className={styles.brand}>
            <Logo className={styles.logo} />
            <span className={styles.name}>Dashboard</span>
          </Link>
          <div className={styles.actions}>
            <ThemeToggle />
            <ProfileMenu />
          </div>
        </div>
        {isHome && <FilterBar />}
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  )
}
